import React from 'react'

const CircularProgress = () => {
  return (
    <div className='circular_progress_indicator'></div>
  )
}

export default CircularProgress